import * as Sentry from '@sentry/react';
import { History } from 'history';
import { is } from 'ramda';
import { getCiVersion } from '../utils/env/getCiVersion';
import { areTrackersEnabled, extractWixHttpErrorDetails, shouldReportError } from './utils';

export function setupSentry(history: History) {
  if (!areTrackersEnabled()) {
    return;
  }

  Sentry.init({
    dsn: 'https://d79cf5e650e045629ea5e346039005b3@sentry-next.wixpress.com/15677',
    debug: false,
    maxBreadcrumbs: 200,
    release: `media-manager-g6@${getCiVersion()}`,
    environment: process.env.NODE_ENV,
    integrations: [
      Sentry.dedupeIntegration(),
      Sentry.extraErrorDataIntegration({
        depth: 6,
      }),
      Sentry.browserTracingIntegration(),
      Sentry.reactRouterV5BrowserTracingIntegration({
        history,
      }),
    ],
    tracesSampleRate: 0.2,
    beforeSend(event, hint) {
      const error = hint.originalException;

      if (is(Error, error) && error.name === 'MediaManagerSDKResponseError' && !shouldReportError(error)) {
        return null;
      }

      const processedEvent = { ...event };
      const { requestId } = extractWixHttpErrorDetails(error);
      const prevTags = processedEvent.tags || {};

      processedEvent.tags = {
        ...prevTags,
        ...(requestId ? { requestId } : {}),
      };

      return processedEvent;
    },
  });
}

// Sentry.extraErrorDataIntegration
// This integration extracts all non-native attributes from the error object and attaches them to the event as extra data.
// If the error object has a .toJSON() method, the ExtraErrorData integration will run it to extract additional information.
// https://docs.sentry.io/platforms/javascript/configuration/integrations/extraerrordata
export type ErrorWithData = Error & {
  data: any;
};
